import React from "react";
// import React, { useEffect } from "react";
// import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

function Facility() {

  // useEffect(()=>{
  //     document.title = 'Elixir | Our Facility';
  //   }, []);

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>Facility</span></h1>
                <h4>Powering Your Prints, Elevating Your Business</h4>
              </div>
            </Col>
            <Col lg={6}>
              <div className="innerPages-box2">
                <div className="aboutPages-box2">
                  <img src={require('../assets/img/facility-page-banner-1.jpg')} className="img-fluid" alt="elixir" />
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <div className="innerPages-box3">      
                <div className="aboutPages-photo">
                  <img src={require('../assets/img/facility-right-banner-1.jpg')} className="img-fluid" alt="elixir" />
                </div>
              </div> 
            </Col>
          </Row>
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box4">
                <div className="contactMap-text">
                  <h3>Precision in Every Print, Quality in Every Machine.</h3>
                </div>
              </div>
            </Col>
            <Col lg={9}>
              <div className="aboutPages-box5">
                <h4>Facility</h4>
                <p>Elixir & AR Graphics is a leading provider of high-quality printing and signage solutions, equipped with cutting-edge technology and advanced machinery to serve businesses worldwide.</p>
                <p>With a commitment to innovation, efficiency, and reliability, our facilities are designed to deliver precision, performance, and consistency across every project.</p>
                <p>From commercial and industrial printing to specialized solutions, we ensure world-class quality, sustainable practices, and unmatched customer support—empowering brands to achieve impactful results.</p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
    </>
  );
}

export default Facility;
